import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const ApplicationsIcon = memo(({ fontSize, color = colors.basic.black, className }: SvgIconProps) => (
  <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} style={{ fontSize }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0846329 3.27666C0.0846329 1.61163 1.4196 0.276665 3.08463 0.276665C4.74966 0.276665 6.08463 1.61163 6.08463 3.27666C6.08463 4.9417 4.74966 6.27666 3.08463 6.27666C1.48238 6.27666 0.0846329 4.94887 0.0846329 3.27666ZM3.08463 1.27666C1.97189 1.27666 1.08463 2.16392 1.08463 3.27666C1.08463 4.38224 2.02022 5.27666 3.08463 5.27666C4.19738 5.27666 5.08463 4.38941 5.08463 3.27666C5.08463 2.16392 4.19738 1.27666 3.08463 1.27666Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0846329 10.7211C0.0846329 9.05608 1.4196 7.72111 3.08463 7.72111C4.74966 7.72111 6.08463 9.05608 6.08463 10.7211C6.08463 12.3861 4.74966 13.7211 3.08463 13.7211C1.48238 13.7211 0.0846329 12.3933 0.0846329 10.7211ZM3.08463 8.72111C1.97189 8.72111 1.08463 9.60836 1.08463 10.7211C1.08463 11.8267 2.02022 12.7211 3.08463 12.7211C4.19738 12.7211 5.08463 11.8339 5.08463 10.7211C5.08463 9.60836 4.19738 8.72111 3.08463 8.72111Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.64017 3.27666C7.64017 1.61163 8.97514 0.276665 10.6402 0.276665C12.3052 0.276665 13.6402 1.61163 13.6402 3.27666C13.6402 4.9417 12.3052 6.27666 10.6402 6.27666C8.97514 6.27666 7.64017 4.9417 7.64017 3.27666ZM10.6402 1.27666C9.52743 1.27666 8.64017 2.16392 8.64017 3.27666C8.64017 4.38941 9.52743 5.27666 10.6402 5.27666C11.7529 5.27666 12.6402 4.38941 12.6402 3.27666C12.6402 2.16392 11.7529 1.27666 10.6402 1.27666Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.64017 10.7211C7.64017 9.05608 8.97514 7.72111 10.6402 7.72111C12.3052 7.72111 13.6402 9.05608 13.6402 10.7211C13.6402 12.3861 12.3052 13.7211 10.6402 13.7211C8.97514 13.7211 7.64017 12.3861 7.64017 10.7211ZM10.6402 8.72111C9.52743 8.72111 8.64017 9.60836 8.64017 10.7211C8.64017 11.8339 9.52743 12.7211 10.6402 12.7211C11.7529 12.7211 12.6402 11.8339 12.6402 10.7211C12.6402 9.60836 11.7529 8.72111 10.6402 8.72111Z"
      fill={color}
    />
  </SvgIcon>
));
